import { createApi, EndpointBuilder } from "@reduxjs/toolkit/query/react";
import { Project } from "@src/types";
import { message } from "antd";

import { createFetchBaseQuery } from "./baseQuery";
import { baseApiSlice } from "./baseApiSlice";

export const projectLeadsApi = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* GET endpoints */
    ...getEndpoints(builder),
  }),
});

function getEndpoints(builder: EndpointBuilder<any, any, any>) {
  return {
    /**
     * Get projects of a given project lead id
     */
    getProjectsByProjectLeadId: builder.query<Project[], number>({
      query: (projectLeadId) => `/project-leads/${projectLeadId}/projects`,
      transformResponse(response) {
        return response.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      },
      transformErrorResponse: async () => {
        message.error("Unable to load projects", 5);
      },
      providesTags: ["Projects"],
    }),
  };
}

export const {
  /* GET endpoints */

  //lazy endpoints
  useLazyGetProjectsByProjectLeadIdQuery,
} = projectLeadsApi;
